/**
 * Một nguồn cho màu + key i18n mức rủi ro điểm ngập (1–5), dùng chung map 2D/3D, chú giải, popup.
 */

export type FloodRiskLevel = 1 | 2 | 3 | 4 | 5;

export type FloodRiskLegendKey = 'low' | 'medium' | 'high' | 'veryHigh' | 'critical';

const RGBA_BY_LEVEL: Record<FloodRiskLevel, [number, number, number, number]> = {
  1: [0, 255, 255, 255],
  2: [255, 215, 0, 255],
  3: [255, 165, 0, 255],
  4: [255, 69, 0, 255],
  5: [255, 0, 0, 255],
};

const KEY_BY_LEVEL: Record<FloodRiskLevel, FloodRiskLegendKey> = {
  1: 'low',
  2: 'medium',
  3: 'high',
  4: 'veryHigh',
  5: 'critical',
};

function clampRiskLevel(level: number): FloodRiskLevel {
  const n = Math.round(level);
  if (n <= 1) return 1;
  if (n >= 5) return 5;
  return n as FloodRiskLevel;
}

function rgbaToHex(r: number, g: number, b: number): string {
  const h = (x: number) => x.toString(16).padStart(2, '0');
  return `#${h(r)}${h(g)}${h(b)}`;
}

/**
 * RGBA cho Deck.gl / Cesium billboard (và mask icon).
 * @param level Mức 1–5 (ngoài phạm vi được kẹp).
 */
export function getFloodRiskRgba(level: number): [number, number, number, number] {
  return RGBA_BY_LEVEL[clampRiskLevel(level)];
}

/** Màu hex cho UI (popup, badge). */
export function getFloodRiskHex(level: number): string {
  const [r, g, b] = getFloodRiskRgba(level);
  return rgbaToHex(r, g, b);
}

/**
 * Key i18n `map.riskLevels.<key>`.
 * @param level Mức 1–5 (ngoài phạm vi được kẹp).
 */
export function getFloodRiskLegendKey(level: number): FloodRiskLegendKey {
  return KEY_BY_LEVEL[clampRiskLevel(level)];
}

/** Thứ tự hiển thị chú giải (cao → thấp). */
export const FLOOD_RISK_LEVELS_DESC: FloodRiskLevel[] = [5, 4, 3, 2, 1];
